export const entitlements = {
  VUS: {
    FCSC_PUBLIC: 'VUS.FCSC_PUBLIC',
    FLASHWARE_CALCULATION: 'VUS.FlashwareCalculation',
    FCSC_MANAGEMENT_DATA: 'VUS.FCSC_ManagementData',
    FCSC_FINLOG_CRYPTO: 'VUS.FCSC_FinlogCrypto',
    FCSC_VORAB_DATA: 'VUS.FCSC_VorabData',
    FCSC_SERIEN_DATA: 'VUS.FCSC_SerienData',
    FCSC_OPEN_SEARCH_DASHBOARD: 'VUS.FCSC_OpenSearchDashboard',
    FCSC_FSF_MANIPULATION: 'VUS.FCSC_FSF_MANIPULATION',
    FCSC_SUMS_ON: 'VUS.FCSC_SUMS_ON',
    FLASHWARE_CALCULATION_WITHOUT_SUMS: 'VUS.FlashwareCalculationWithoutSums',
    FCSC_FSF_DOWNLOAD_WITHOUT_SUMS: 'VUS.FCSC_FSF_DOWNLOAD_WITHOUT_SUMS',
    FCSC_FSF_DOWNLOAD_WITH_SUMS:'VUS.FCSC_FSF_DOWNLOAD_WITH_SUMS',
    FCSC_UI_ACCESS: 'VUS.FCSC_UIAccess',
  },
};

export function getEntitlements(entitlementGroup: any) {
  return Object.keys(entitlementGroup).map((element) => {
    return entitlementGroup[element];
  });
}
